import { parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import TransportContainer from '../models/TransportContainer';
import TransportDetails from '../models/TransportDetails';

const SCHEMA = {
  pickup: parsePickup,
  delivery: parseDelivery,
  modifiedOn: (data: any) => parseMoment(data.modifiedOn),
  modifiedBy: (data: any) => User.withFullName(data.modifiedByName),
};

const PICK_UP_SCHEMA = {
  address: 'pickUpAddress',
  time: (data: any) => parseMoment(data.pickUpPlanning),
  driver: (data: any) => User.withIdAndFullName(data.pickUpOutletUser?.id, data.pickUpOutletUser?.name),
  note: 'pickUpAdditionalInfo',
};

const DELIVERY_SCHEMA = {
  address: 'deliveryAddress',
  time: (data: any) => parseMoment(data.deliveryPlanning),
  driver: (data: any) => User.withIdAndFullName(data.deliveryOutletUser?.id, data.deliveryOutletUser?.name),
  note: 'deliveryAdditionalInfo',
};

export function parseTransportContainer(data: any): TransportContainer | null {
  return parseEntity(data, SCHEMA, TransportContainer);
}

function parsePickup(data: any): TransportDetails | null {
  if (data.hasNoPickup) return null;
  if (!data.pickUpAddress && !data.pickUpPlanning && !data.pickUpAdditionalInfo) return null;
  return parseEntity(data, PICK_UP_SCHEMA, TransportDetails);
}

function parseDelivery(data: any): TransportDetails | null {
  if (data.hasNoDelivery) return null;
  if (!data.deliveryAddress && !data.deliveryPlanning && !data.deliveryAdditionalInfo) return null;
  return parseEntity(data, DELIVERY_SCHEMA, TransportDetails);
}
